var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMisiIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41602 16.6384L8.91602 14.3884L13.416 16.6384V12.1384C13.041 12.6634 12.516 13.1134 11.916 13.4884C11.016 14.0884 10.041 14.3884 8.91602 14.3884C7.79102 14.3884 6.81602 14.0884 5.91602 13.4884C5.31602 13.1134 4.79102 12.6634 4.41602 12.1384V16.6384Z",
    fill: "url(#paint0_linear_493_700)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91602 14.3884L4.41602 16.6384V12.1384C4.79102 12.6634 5.31602 13.1134 5.91602 13.4884C6.81602 14.0884 7.79102 14.3884 8.91602 14.3884ZM8.91602 14.3884L13.416 16.6384V12.1384C13.041 12.6634 12.516 13.1134 11.916 13.4884C11.016 14.0884 10.041 14.3884 8.91602 14.3884Z",
    stroke: "url(#paint1_linear_493_700)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91602 2.38843C5.4268 2.38843 2.54102 5.27421 2.54102 8.76343C2.54102 10.2076 3.0476 11.5607 3.81072 12.5814C4.25565 13.2018 4.85772 13.7102 5.50922 14.1186C6.53063 14.7971 7.64762 15.1384 8.91602 15.1384C10.2177 15.1384 11.3242 14.7019 12.2939 14.1363L12.3038 14.1305L12.3135 14.1244C12.971 13.7135 13.5788 13.2009 14.0263 12.5744L14.0295 12.5699L14.0327 12.5653C14.7732 11.4957 15.291 10.2246 15.291 8.76343C15.291 5.27421 12.4052 2.38843 8.91602 2.38843Z",
    fill: "url(#paint2_linear_493_700)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91602 6.51343C9.30977 7.58218 10.0973 8.36968 11.166 8.76343C10.0973 9.15718 9.30977 9.94468 8.91602 11.0134C8.52227 9.94468 7.73477 9.15718 6.66602 8.76343C7.73477 8.36968 8.52227 7.58218 8.91602 6.51343Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_493_700",
    x1: 3.76384,
    y1: 10.9838,
    x2: 5.97096,
    y2: 19.2976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA8517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_493_700",
    x1: 3.76384,
    y1: 10.9838,
    x2: 5.97096,
    y2: 19.2976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA8517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_493_700",
    x1: 1.6171,
    y1: -0.882954,
    x2: 12.0612,
    y2: 18.7874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA8517"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisiIcon);
export default __webpack_public_path__ + "static/media/MisiIcon.055793da9f33f280abf47a383305e08a.svg";
export { ForwardRef as ReactComponent };